import { Modal } from "@mantine/core";
import { LoadIcon, CloseIcon } from "@form/components/common/icons";
import {
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
  useRef,
} from "react";
import { useCounter } from "@mantine/hooks";

enum Stage {
  pending,
  countdown,
}

const RedirectModal: FunctionComponent<{
  opened: boolean;
  setOpened: (opened: boolean) => void;
  link?: string;
}> = ({ opened, setOpened, link }) => {
  const [stage, setStage] = useState(Stage.pending);
  const [count, handlers] = useCounter(5, { min: 0, max: 5 });
  const countRef = useRef<{
    timer: NodeJS.Timer;
  }>({
    timer: null as any,
  });
  const close = useCallback(() => {
    setStage(Stage.pending);
    handlers.reset();
    setOpened(false);
  }, []);

  useEffect(() => {
    if (link && opened) {
      setStage(Stage.countdown);
    }
  }, [link, opened]);

  useEffect(() => {
    if (stage === Stage.countdown) {
      countRef.current.timer = setInterval(() => {
        handlers.decrement();
      }, 1000);
      return () => {
        clearInterval(countRef.current.timer);
      };
    }
  }, [stage]);

  useEffect(() => {
    if (count === 0 && opened && link) {
      window.location.href = link;
      close();
    }
  }, [count, link, close, opened]);

  return (
    <Modal
      centered
      opened={opened}
      trapFocus
      withCloseButton={false}
      onClose={close}
      classNames={{
        content: "!bg-bg_light_blue dark:!bg-[#1D283C]",
      }}
    >
      <div className="flex flex-col items-center text-center pb-[60px] pt-10 px-2 relative dark:text-gray_f9">
        <div className="relative">
          <div className="w-full h-full absolute left-0 top-0 flex items-center justify-center font-bold text-body">
            {count}
          </div>
          <LoadIcon className="animate-spin"></LoadIcon>
        </div>
        <div className="font-bold mt-7">
          You’re being redirected to another site
        </div>
        <div className="text-center mt-2">
          The form owner wants to redirect you to their site. This will open in
          a new tab in the same window.
        </div>
        <CloseIcon
          className="absolute top-0 right-0 fill-primary h-3 w-3 cursor-pointer"
          onClick={close}
        ></CloseIcon>
      </div>
    </Modal>
  );
};

export default RedirectModal;
